import { Box, Grid, Typography, Link, IconButton, Stack } from "@mui/material";
import { socialLinks } from "../Constants/NavLinks";

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        background: "rgba(255, 255, 255, 1)",
        color: "#222",
      }}
    >
      <Grid
        container
        spacing={4}
        px={{ xs: 5, sm: 10, md: 15, lg: 25 }}
        py={3}
        justifyContent={{
          lg: "space-between",
          md: "space-between",
          xs: "center",
          sm: "center",
        }}
      >
        {/* Logo & Social */}
        <Grid item xs={12} md={4}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <img
              src="/logo.png"
              alt="FlyHi Logo"
              style={{
                height: "100px",
                width: "auto",
                objectFit: "contain",
              }}
            />
          </Box>
          <Typography
            variant="h5"
            fontWeight={600}
            sx={{ textAlign: "center" }}
          >
            FlyHi Trans Inc.
          </Typography>
          <Typography>
            {socialLinks.map(({ label, href, icon }) => (
              <a
                key={label}
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "none" }}
              >
                <IconButton
                  sx={{ color: "rgba(33, 93, 213, 1)" }}
                  aria-label={label}
                >
                  {icon}
                </IconButton>
              </a>
            ))}
          </Typography>
        </Grid>

        {/* Quick Links */}
        <Grid
          item
          xs={12}
          md={4}
          sx={{ textAlign: { xs: "center", md: "left" } }}
        >
          <Typography
            variant="h5"
            fontWeight={600}
            gutterBottom
            color="rgba(33, 93, 213, 1)"
          >
            Quick Links
          </Typography>
          <Stack spacing={1}>
            {[
              "Home",
              "About Us",
              "Privacy Policy",
              "Contact Us",
              "Terms and Conditions",
            ].map((text) => (
              <Link
                key={text}
                href="#"
                underline="hover"
                color="rgba(0, 0, 0, 1)"
              >
                {text}
              </Link>
            ))}
          </Stack>
        </Grid>

        {/* Contact Info */}
        <Grid
          item
          xs={12}
          md={4}
          sx={{ textAlign: { xs: "center", md: "left" } }}
        >
          <Typography
            variant="h5"
            fontWeight={600}
            gutterBottom
            color="rgba(33, 93, 213, 1)"
          >
            Get In Touch
          </Typography>
          <Stack spacing={1}>
  <Typography
    color="rgba(0, 0, 0, 1)"
    sx={{ textAlign: { xs: "center", md: "left" } }}
  >
    <b>24/7 Helpline:</b>{" "}
    <Link href="tel:+918329409000" underline="hover" color="inherit">
      +91 832-940-9000
    </Link>
  </Typography>

  <Typography sx={{ textAlign: { xs: "center", md: "left" } }}>
    <b>Email:</b>{" "}
    <Link href="mailto:dispatch@flyhitrans.com" underline="hover" color="inherit">
      dispatch@flyhitrans.com
    </Link>
  </Typography>

  <Typography
    color="rgba(0, 0, 0, 1)"
    sx={{ textAlign: { xs: "center", md: "left" } }}
  >
    <b>Address:</b>
    <br />
    17244 Badtke Rd
    <br />
    Hockley, TX 77477,
    <br />
    United States of America
  </Typography>
</Stack>

        </Grid>
      </Grid>

      {/* Bottom Bar */}
      <Box
        sx={{
          width: "100%",
          backgroundColor: "#1b305a",
          textAlign: "center",
          mt: 2,
        }}
      >
        <Typography
          component="p"
          variant="body"
          color="white"
          py={2}
          fontWeight={700}
          sx={{ wordBreak: "break-word" }}
        >
          Copyright © 2025 All rights reserved | Powered by FlyHi Infotech
        </Typography>
      </Box>
    </Box>
  );
};

export default Footer;
